export const SERVER_ERROR =
  "Something is technically wrong. Thanks for noticing - we're going to fix it up and have things back to normal soon.";

export const API_URLS = {
  workspace: {
    byReference: { url: '/api/workspace/reference', method: 'get' },
    list: { url: '/api/workspace', method: 'get' },
    information: { url: '/api/workspace', method: 'post' },
    management: { url: '/api/workspace', method: 'put' },
    invitation: { url: '/api/workspace/invitation', method: 'post' },
    plan: { url: '/api/workspace/subscription', method: 'post' },
    ipAddress: { url: '/api/workspace/ip_address', method: 'get' },
  },
  auth: {
    checkEmailExists: { url: '/api/auth/emailExists/', method: 'post' },
    login: { url: '/api/auth/login', method: 'post' },
    signup: { url: '/api/auth/signup', method: 'post' },
    resendEmail: { url: '/api/auth/resend_verification', method: 'post' },
    emailConfirmation: { url: '/api/auth/confirmation', method: 'get' },
    forgotPassword: { url: '/api/auth/forgot_password', method: 'post' },
    resetPassword: { url: '/api/auth/reset_password', method: 'post' },
    resetPasswordToken: { url: '/api/auth/reset_password', method: 'get' },
    googleLogin: { url: '/api/auth/google/login', method: 'post' },
    googleSignup: { url: '/api/auth/google/signup', method: 'post' },
  },
  onboarding: {
    basic: { url: '/api/business/add/basic_information', method: 'post' },
    domain: { url: '/api/business/add/domain', method: 'put' },
    location: { url: '/api/business/add/location', method: 'put' },
    mobile: { url: '/api/business/add/mobile', method: 'put' },
    verifyMobile: { url: '/api/business/add/mobile_otp', method: 'put' },
  },
  invitation: {
    verification: { url: '/api/auth/invitation', method: 'get' },
    add: { url: '/api/auth/invitation', method: 'post' },
  },
  update2fa: {
    url: '/api/auth/check_google_2fa',
    method: 'post',
  },
};

// app context action types
export const APP_CONTEXT = {
  UPDATE_TWO_FA: 'UPDATE_TWO_FA',

  SET_APP_PROPS: 'SET_APP_PROPS',
  RESET_APP_PROPS: 'RESET_APP_PROPS',
  IS_AUTHENTICATED: 'IS_AUTHENTICATED',

  LOGIN_LOADING: 'LOGIN_LOADING',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILURE: 'LOGIN_FAILURE',

  SIGNUP_LOADING: 'SIGNUP_LOADING',
  SIGNUP_SUCCESS: 'SIGNUP_SUCCESS',
  SIGNUP_FAILURE: 'SIGNUP_FAILURE',

  RESEND_EMAIL_LOADING: 'RESEND_EMAIL_LOADING',
  RESEND_EMAIL_SUCCESS: 'RESEND_EMAIL_SUCCESS',
  RESEND_EMAIL_FAILURE: 'RESEND_EMAIL_FAILURE',

  CONFIRM_EMAIL_LOADING: 'CONFIRM_EMAIL_LOADING',
  CONFIRM_EMAIL_SUCCESS: 'CONFIRM_EMAIL_SUCCESS',
  CONFIRM_EMAIL_FAILURE: 'CONFIRM_EMAIL_FAILURE',

  FORGOT_PASSWORD_LOADING: 'FORGOT_PASSWORD_LOADING',
  FORGOT_PASSWORD_SUCCESS: 'FORGOT_PASSWORD_SUCCESS',
  FORGOT_PASSWORD_FAILURE: 'FORGOT_PASSWORD_FAILURE',

  RESET_PASSWORD_VERIFY_LOADING: 'RESET_PASSWORD_VERIFY_LOADING',
  RESET_PASSWORD_VERIFY_SUCCESS: 'RESET_PASSWORD_VERIFY_SUCCESS',
  RESET_PASSWORD_VERIFY_FAILURE: 'RESET_PASSWORD_VERIFY_FAILURE',

  RESET_PASSWORD_LOADING: 'RESET_PASSWORD_LOADING',
  RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_FAILURE: 'RESET_PASSWORD_FAILURE',

  GOOGLE_LOGIN_LOADING: 'GOOGLE_LOGIN_LOADING',
  GOOGLE_LOGIN_SUCCESS: 'GOOGLE_LOGIN_SUCCESS',
  GOOGLE_LOGIN_FAILURE: 'GOOGLE_LOGIN_FAILURE',

  AUTH_INVITATION_LOADING: 'AUTH_INVITATION_LOADING',
  AUTH_INVITATION_SUCCESS: 'AUTH_INVITATION_SUCCESS',
  AUTH_INVITATION_FAILURE: 'AUTH_INVITATION_FAILURE',

  ADD_INVITATION_LOADING: 'ADD_INVITATION_LOADING',
  ADD_INVITATION_SUCCESS: 'ADD_INVITATION_SUCCESS',
  ADD_INVITATION_FAILURE: 'ADD_INVITATION_FAILURE',

  GET_WSREFERNCE_LOADING: 'GET_WSREFERNCE_LOADING',
  GET_WSREFERNCE_SUCCESS: 'GET_WSREFERNCE_SUCCESS',
  GET_WSREFERNCE_FAILURE: 'GET_WSREFERNCE_FAILURE',
};

// user context action types
export const USER_CONTEXT = {
  SET_USER_PROPS: 'SET_USER_PROPS',
  RESET_USER_PROPS: 'RESET_USER_PROPS',

  BASIC_INFORMATION_LOADING: 'BASIC_INFORMATION_LOADING',
  BASIC_INFORMATION_SUCCESS: 'BASIC_INFORMATION_SUCCESS',
  BASIC_INFORMATION_FAILURE: 'BASIC_INFORMATION_FAILURE',

  DOMAIN_LOADING: 'DOMAIN_LOADING',
  DOMAIN_SUCCESS: 'DOMAIN_SUCCESS',
  DOMAIN_FAILURE: 'DOMAIN_FAILURE',

  LOCATION_LOADING: 'LOCATION_LOADING',
  LOCATION_SUCCESS: 'LOCATION_SUCCESS',
  LOCATION_FAILURE: 'LOCATION_FAILURE',

  MOBILE_NO_LOADING: 'MOBILE_NO_LOADING',
  MOBILE_NO_SUCCESS: 'MOBILE_NO_SUCCESS',
  MOBILE_NO_FAILURE: 'MOBILE_NO_FAILURE',

  MOBILILE_NO_VERIFY_LOADING: 'MOBILILE_NO_VERIFY_LOADING',
  MOBILILE_NO_VERIFY_SUCCESS: 'MOBILILE_NO_VERIFY_SUCCESS',
  MOBILILE_NO_VERIFY_FAILURE: 'MOBILILE_NO_VERIFY_FAILURE',

  EMAIL_EXISTS_LOADING: 'EMAIL_EXISTS_LOADING',
  EMAIL_EXISTS_SUCCESS: 'EMAIL_EXISTS_SUCCESS',
  EMAIL_EXISTS_FAILURE: 'EMAIL_EXISTS_FAILURE',

  EMAIL_LOADING: 'EMAIL_LOADING',
  EMAIL_SUCCESS: 'EMAIL_SUCCESS',
  EMAIL_FAILURE: 'EMAIL_FAILURE',

  GOOGLE_LOGIN_SUCCESS: 'GOOGLE_LOGIN_SUCCESS',

  CREATE_WORKSPACE_LOADING: 'CREATE_WORKSPACE_LOADING',
  CREATE_WORKSPACE_SUCCESS: 'CREATE_WORKSPACE_SUCCESS',
  CREATE_WORKSPACE_FAILURE: 'CREATE_WORKSPACE_FAILURE',

  GET_WORKSPACES_LOADING: 'GET_WORKSPACES_LOADING',
  GET_WORKSPACES_SUCCESS: 'GET_WORKSPACES_SUCCESS',
  GET_WORKSPACES_FAILURE: 'GET_WORKSPACES_FAILURE',

  ACCEPT_WS_INVITATION_LOADING: 'ACCEPT_WS_INVITATION_LOADING',
  ACCEPT_WS_INVITATION_SUCCESS: 'ACCEPT_WS_INVITATION_SUCCESS',
  ACCEPT_WS_INVITATION_FAILURE: 'ACCEPT_WS_INVITATION_FAILURE',

  MANAGE_WORKSPACE_LOADING: 'MANAGE_WORKSPACE_LOADING',
  MANAGE_WORKSPACE_SUCCESS: 'MANAGE_WORKSPACE_SUCCESS',
  MANAGE_WORKSPACE_FAILURE: 'MANAGE_WORKSPACE_FAILURE',

  INVITATION_WORKSPACE_LOADING: 'INVITATION_WORKSPACE_LOADING',
  INVITATION_WORKSPACE_SUCCESS: 'INVITATION_WORKSPACE_SUCCESS',
  INVITATION_WORKSPACE_FAILURE: 'INVITATION_WORKSPACE_FAILURE',

  IP_ADDRESS_LOADING: 'IP_ADDRESS_LOADING',
  IP_ADDRESS_SUCCESS: 'IP_ADDRESS_SUCCESS',
  IP_ADDRESS_FAILURE: 'IP_ADDRESS_FAILURE',
};
